import { intFromUnknown } from '@/lib/primitive-utils';
import { WidthField } from './shared/tolerance-width-fields';
import type { BuilderPropertyRecord, ShortAnswerToolSettingsProps } from './tool-defaults';

export function selectCombinatoricsToolProps(p: BuilderPropertyRecord): { width: number } {
    return {
        width: intFromUnknown(p.width, 150),
    };
}

function CombinatoricsToolSettingsInner({ width, onPatch }: { width: number; onPatch: (patch: BuilderPropertyRecord) => void }) {
    return (
        <div className="space-y-3">
            <WidthField
                width={width}
                onPatch={onPatch}
            />
        </div>
    );
}

export function CombinatoricsToolSettings({ builderProps, onPatch }: ShortAnswerToolSettingsProps) {
    const { width } = selectCombinatoricsToolProps(builderProps);
    return (
        <CombinatoricsToolSettingsInner
            width={width}
            onPatch={onPatch}
        />
    );
}
